import { ReactNode } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import { Theme } from "@mui/material/styles";

// Material Dashboard 2 PRO React TS components
import MDBox from "components/MDBox";

// Material Dashboard 2 PRO React TS examples components
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import PageLayout from "examples/LayoutContainers/PageLayout";

// Authentication pages components
import Footer from "layouts/authentication/components/Footer";

// Declaring props types for BasicLayout
interface Props {
  image: string;
  children: ReactNode;
}

function BasicLayout({ image, children }: Props): JSX.Element {
  return (
    <PageLayout>
      <MDBox
        position="fixed"
        width="100%"
        height="100%"
        sx={{
          backgroundImage: ({
            functions: { linearGradient, rgba },
            palette: { gradients },
          }: Theme) =>
            image &&
            `${linearGradient(
              rgba(gradients.dark.main, 0.6),
              rgba(gradients.dark.state, 0.6)
            )}, url(${image})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      />
      <MDBox
        position="relative"
        zIndex={1}
        px={{ xs: 0, sm: 1 }}
        width={{ xs: "100%", sm: "100%" }}
        minHeight="100vh"
        mx="auto"
        display="flex"
        flexDirection="column"
        justifyContent={{ xs: "center", sm: "center" }}
        pt={{ xs: 3, sm: 0 }}
        pb={{ xs: 11, sm: 0 }}
      >
        <Grid
          container
          spacing={1}
          justifyContent="center"
          alignItems="center"
          sx={{ flex: 1 }}
        >
          <Grid
            item
            xs={12}
            sm={9}
            md={8}
            lg={8}
            xl={4}
            sx={{
              width: { xs: "95vw", sm: "auto" },
              maxWidth: { xs: "95vw", sm: "none" },
            }}
          >
            {children}
          </Grid>
        </Grid>
        <Footer light />
      </MDBox>
    </PageLayout>
  );
}

export default BasicLayout;
